import { type JSX, useState } from 'react';

import { EloTooltip } from '@plurall/elo-v3';
import { createFileRoute, redirect } from '@tanstack/react-router';

import { Anchor } from '@/components/Anchor/Anchor';
import { Portal } from '@/components/Portal/Portal';
import { resolvePath } from '@/lib/formatters/resolveEnvUrl';

function Index(): JSX.Element {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <div>
        <h1>Hello World</h1>
      </div>

      <Anchor name='modal-button'>
        <EloTooltip
          closeDelay={100}
          content='Click to open a modal dialog'
          data-test-id='elo-tooltip'
          openDelay={100}
          position='top'>
          <button
            onClick={() => setIsModalOpen(true)}
            style={{ padding: '0.75rem 1.5rem', cursor: 'pointer' }}>
            Open Modal
          </button>
        </EloTooltip>
      </Anchor>

      <Portal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        positionArea='center'
        showBackdrop={true}
        closeOnEscape={true}
        closeOnOutsideClick={true}>
        <div
          style={{
            background: 'white',
            padding: '2rem',
            borderRadius: '8px',
            boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
          }}>
          <h2>Modal Title</h2>
          <p>This is a centered modal with backdrop</p>
          <button onClick={() => setIsModalOpen(false)}>Close</button>
        </div>
      </Portal>
    </>
  );
}

export const Route = createFileRoute('/')({
  beforeLoad: () => {
    throw redirect({ href: resolvePath('home') });
  },
  component: Index,
});
